import { render } from "./index.vue?vue&type=template&id=190b447f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=190b447f&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-190b447f"],['__file',"src/views/oa/setupConfig/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "190b447f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('190b447f', __exports__)) {
    console.log('reload')
    api.reload('190b447f', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=190b447f&scoped=true", () => {
    console.log('re-render')
    api.rerender('190b447f', render)
  })

}


export default __exports__